<mat-dialog-content>
  <div class="filter-container">
    <button type="button" class="cmn-close filter-close" (click)="onClose()"></button>

    <div class="filter-header">
      <h3 class="filter-title">Advanced Filters</h3>
    </div>

    <form [formGroup]="filterForm">
      <div class="filter-content">

        <div class="filter-group">
          <label class="filter-label">Date Range</label>
          <div class="date-range-group">
            <input type="date" formControlName="startDate" class="filter-input" [max]="maxDateString"
              (change)="dateRangeValidator()" />
            <input type="date" formControlName="endDate" class="filter-input" [min]="minEndDateString"
              [max]="maxDateString" (change)="dateRangeValidator()" />
          </div>

          <div *ngIf="dateError" class="text-danger mt-1">
            {{ dateError }}
          </div>
        </div>

        <div class="filter-group">
          <label class="filter-label">Membership Type</label>
          <select formControlName="membership" class="filter-select">
            <option value="">All Memberships</option>
            <option value="isPremiumPlus">Premium Plus</option>
            <option value="isAdfree">AdFree</option>
            <option value="isPremium">Premium</option>
            <option value="isFree">Free</option>
          </select>
        </div>

        <div class="filter-group" *ngIf="
          filterForm.get('membership')?.value !== 'isFree' &&
          filterForm.get('membership')?.value !== 'isAdfree'">
          <label class="filter-label">Billing Cycle</label>
          <select formControlName="type" class="filter-select">
            <option value="">All Types</option>
            <option value="Monthly">Monthly</option>
            <option value="Yearly">Yearly</option>
          </select>
        </div>

        <div class="filter-group">
          <label class="filter-label">Marketing Consent</label>
          <select formControlName="marketing" class="filter-select">
            <option value="">All Users</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button" class="filter-btn filter-btn-secondary" (click)="onReset()">
    <span>Reset</span>
  </button>
  <button type="button" class="filter-btn filter-btn-primary" (click)="onApply()">
    <span>Apply Filters</span>
  </button>
</mat-dialog-actions>
